import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { setupNavigation } from "../../redux/actions/navItemsActions";
import PropTypes from "prop-types";
import UploadedRoutesControl from "./UploadedRoutesControl";
import DownloadedRoutesControl from "./DownloadedRoutesControl";

function RoutesPage(
    {
        setupNavigation,
        user
    }
) {
    const [activeForm, setActiveForm] = useState({ form: "uploads" });
    const navigationItems =
    {
        sections: [{
            name: 'Admin',
            items: [
                {
                    path: '/_adm/dashboard',
                    text: 'Dashboard',
                    icon: 'fas fa-tachometer-alt'
                },
                {
                    path: '/_adm/users',
                    text: 'Users',
                    icon: 'fas fa-user'
                },
                {
                    path: '/_adm/groups',
                    text: 'Groups',
                    icon: 'fas fa-users'
                },
                {
                    path: '/_adm/routes',
                    text: 'Routes',
                    icon: 'fas fa-route'
                },
                {
                    path: '/_adm/errors',
                    text: 'Errors',
                    icon: 'fas fa-bug'
                }
            ]
        }]
    };

    useEffect(() => {
        document.title = "Administration | JustGoRide";
        setupNavigation(navigationItems);

    }, []);


    function setForm(e) {
        e.preventDefault();
        var form = e.target.title;
        setActiveForm(setActiveForm => ({
            ...setActiveForm,
            form: form
        }));
    }

    return (
        <div className="mt-2">
            <h3 className="ml-3 mb-3">Administration - Routes</h3>
            <div className="profile-tab">
                <ul className="nav nav-tabs">
                    <li className="nav-item">
                        <a title="uploads" className={activeForm.form == "uploads" ? "nav-link active" : "nav-link"} href="#" onClick={setForm}><span title="uploads" className="fas fa-cloud-upload-alt mr-1"></span>Uploads</a>
                    </li>
                    <li className="nav-item">
                        <a title="downloads" className={activeForm.form == "downloads" ? "nav-link active" : "nav-link"} href="#" onClick={setForm}><span title="downloads" className="fas fa-cloud-download-alt mr-1"></span>Downloads</a>
                    </li>
                </ul>
            </div>
            <div>
                {
                    (() => {
                        switch (activeForm.form) {
                            case "uploads":
                                return (
                                    <div className="">
                                        <UploadedRoutesControl />
                                    </div>
                                )
                            case 'downloads':
                                return (
                                    <div className="">
                                        <DownloadedRoutesControl />
                                    </div>
                                )
                            default:
                                return null;
                        }
                    })()
                }
            </div>
        </div>
    );
}

RoutesPage.propTypes = {
    setupNavigation: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired
}

function mapStateToProps(state) {
    return {
        user: state.user
    };
}

const mapDispatchToProps = {
    setupNavigation
}

export default connect(mapStateToProps, mapDispatchToProps)(RoutesPage);



// WEBPACK FOOTER //
// ./src/components/administration/RoutesPage.js